import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { MoveRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function Hero({ onOpenWaitlistModal }: { onOpenWaitlistModal: () => void }) {
  const navigate = useNavigate();
  const [titleNumber, setTitleNumber] = useState(0);
  const   titles = useMemo(
    () => ["Compliant", "Automated", "Sustainable", "Scalable", "Future-Ready", "Waste-Free"],
    []  
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (titleNumber === titles.length - 1) {
        setTitleNumber(0);
      } else {
        setTitleNumber(titleNumber + 1);
      }
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, [titleNumber, titles]);

  return (
    <div className="relative z-0 bg-background">
      <div className="w-full">
        <div className="container mx-auto px-4 sm:px-6 lg:px-12 flex items-center justify-center min-h-[50vh] pt-20 sm:pt-8 md:pt-10 lg:pt-14">
          <div className="flex gap-4 sm:gap-6 pt-6 sm:pt-8 lg:pt-12 items-center justify-center flex-col max-w-7xl mx-auto">
            <div className="flex gap-4 flex-col items-center">
              <h1 className="text-5xl sm:text-4xl md:text-6xl lg:text-7xl max-w-2xl tracking-tighter text-center">
                <span className="text-foreground font-semibold">Making SME Manufacturing</span> 
                <span className="relative flex w-full min-h-[60px] sm:min-h-[70px] md:min-h-[80px] justify-center overflow-hidden text-center pt-1 sm:pt-2 md:pb-4 md:pt-1">
                  &nbsp;
                  {titles.map((title, index) => (
                    <motion.span
                      key={index}
                      className="absolute font-semibold text-[#00DC82]"
                      initial={{ opacity: 0, y: "-100" }}
                      transition={{ type: "spring", stiffness: 50 }}
                      animate={
                        titleNumber === index
                          ? {
                              y: 0,
                              opacity: 1,
                            }
                          : {
                              y: titleNumber > index ? -150 : 150,
                              opacity: 0,
                            }
                      }
                    >
                      {title}
                    </motion.span>
                  ))}
                </span>
              </h1>

              
            
              <p className="text-base sm:text-lg md:text-xl leading-relaxed tracking-tight text-muted-foreground max-w-4xl text-center mt-2 md:mt-4 lg:mt-6">
                 Imagine reclaiming over 100 hours a year — no more spreadsheets or manual reporting. 
              </p>
              <p className="text-base sm:text-lg md:text-xl leading-relaxed tracking-tight text-muted-foreground max-w-4xl text-center mt-0.5 md:mt-1 lg:mt-1.5">
              Sentiri turns compliance into a competitive edge, handling day-to-day tracking and sustainability metrics so you can focus on what matters: delivering exceptional products, reducing waste and boosting profitability.
              </p>

            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center w-full px-4 sm:px-0 mt-2">
              <Button 
                size="lg" 
                className="gap-4 bg-[#00DC82] text-white hover:bg-[#00DC82]/90 w-full sm:w-auto text-sm sm:text-base py-6 sm:py-7 font-medium"
                onClick={onOpenWaitlistModal}
              >
                Join Waitlist
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                className="box-border border-2 gap-4 border-[#00DC82] !text-[#00DC82] hover:bg-[#00DC82]/10 dark:border-white hover:border-[#00DC82] w-full sm:w-auto text-sm sm:text-base py-[22px] sm:py-[26px] font-medium transition-colors duration-300"
                onClick={() => navigate('/survey')}
              >
                Take Survey
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}